import { render, staticRenderFns } from "./AssistIcon.vue?vue&type=template&id=0700abc2"
var script = {}
import style0 from "./AssistIcon.vue?vue&type=style&index=0&id=0700abc2&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0700abc2')) {
      api.createRecord('0700abc2', component.options)
    } else {
      api.reload('0700abc2', component.options)
    }
    module.hot.accept("./AssistIcon.vue?vue&type=template&id=0700abc2", function () {
      api.rerender('0700abc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/AssistIcon.vue"
export default component.exports